var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L112 54.5L58.5 1L5 54.5L58.5 108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 61.0644L58.5 114.564L112 61.0644V54.5L58.5 108L5 54.5V61.0644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 54.5V61.0644L58.5 114.564L112 61.0644V54.5M5 54.5L58.5 108L112 54.5M5 54.5L58.5 1L112 54.5",
    stroke: "#DE352B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.564C79.393 93.6714 112 61.0644 112 61.0644V54.5517L58.5 108V111.282C58.5 111.282 58.5 113.283 58.5 114.564Z",
    fill: "#DE352B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L5 54.5V61.0644C25.893 81.9575 37.607 93.6714 58.5 114.564C58.5 113.283 58.5 111.282 58.5 111.282V108Z",
    fill: "#8C0E05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8425 41.32C51.6425 41.32 53.8825 42.1467 55.5625 43.8C57.2692 45.4267 58.1225 47.88 58.1225 51.16H53.2825C53.2825 49.2667 52.8825 47.8267 52.0825 46.84C51.2825 45.8533 50.2025 45.36 48.8425 45.36C47.1092 45.36 45.8158 46.0667 44.9625 47.48C44.1092 48.8933 43.6825 50.8933 43.6825 53.48V55.32C43.6825 57.9067 44.1225 59.9067 45.0025 61.32C45.9092 62.7067 47.2425 63.4 49.0025 63.4C50.4158 63.4 51.5225 62.92 52.3225 61.96C53.1225 60.9733 53.5225 59.5333 53.5225 57.64H58.1225C58.1225 60.84 57.2692 63.28 55.5625 64.96C53.8825 66.6133 51.6425 67.44 48.8425 67.44C45.6158 67.44 43.1358 66.36 41.4025 64.2C39.6692 62.0133 38.8025 58.7467 38.8025 54.4C38.8025 50.0267 39.6692 46.76 41.4025 44.6C43.1358 42.4133 45.6158 41.32 48.8425 41.32ZM59.3203 41.8H64.2003L69.4803 59.84H69.6403L74.8403 41.8H79.4403L71.7603 67H67.0003L59.3203 41.8Z",
    fill: "#DE352B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvFront);
export default __webpack_public_path__ + "static/media/cv-front.d75cd557029863c0714c81259189746f.svg";
export { ForwardRef as ReactComponent };